import { render, staticRenderFns } from "./QCCollapseItem.vue?vue&type=template&id=33b401ba"
import script from "./QCCollapseItem.vue?vue&type=script&lang=js"
export * from "./QCCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./QCCollapseItem.vue?vue&type=style&index=0&id=33b401ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports